import styled from "styled-components";
import ConstellationLogoSvg from "../../img/logos/constellation-logo.svg";
import {Col, Container, Row} from "react-grid-system";

export const FooterContainer = styled(Container)`
  width: 100%;
  height: 570px;
  position: relative;
  z-index: 490;
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    height: calc(50%);
  }
`;

export const MailContainer = styled(Row)`
  background-color: ${(props) => props.theme.footerMailColor};
  height: 150px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    height: 201px;
  }
`;

export const DescriptionMessage = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 40px;

  strong {
    color: ${(props) => props.theme.menuLabelColor};
  }

  span {
    color: ${(props) => props.theme.menuLabelColor};
  }

  font-size: 22px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    align-items: center;
    margin-top: 41px;
  }
`;

export const InputMail = styled.form`
  margin-top: 40px;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;

  input {
    padding: 5px 0px;
    width: 100%;
    background: none;
    border: none;
    border-bottom: 1px solid #ffffff80;
    outline: none;

    &::placeholder {
      margin-bottom: 5px;
      color: #ffffff80;
      font-style: normal;
      font-size: 28px;
      line-height: 32px;

      @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
        font-size: 14px;
      }
    }
  }

  input,
  select,
  textarea {
    color: ${(props) => props.theme.menuLabelColor};
    font-style: normal;
    font-size: 20px;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      font-size: 14px;
    }
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    justify-content: center;
    margin-bottom: 33px;
  }
`;

export const SubmitButton = styled.button`
  background: none;
  border: none;
  position: absolute;
  right: 0px;
  color: ${(props) => props.theme.menuLabelColor};
  cursor: pointer;

  font-style: normal;
  font-weight: 400;
  font-size: 28px;

  display: flex;
  align-items: center;

  span {
    margin-right: 5px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    font-size: 14px;
  }
`;

export const RedirectsContainer = styled(Row)`
  width: 100%;
  padding-top: 59px;
  background-color: ${(props) => props.theme.background};

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    height: auto;
    flex-direction: column;
  }
`;

export const ConstellationInformationContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 50px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    align-items: center;
    margin-bottom: 30px;
  }
`;

export const ConstellationContainer = styled.div`
  display: flex;
  align-items: center;

  color: ${(props) => props.theme.constellationLogoColor};

  aside {
    margin-left: 10px;
  }
`;

export const ConstellationLogo = styled(ConstellationLogoSvg)`
  path {
    fill: ${(props) => props.theme.constellationLogoColor};
  }
`;

export const ConstellationRights = styled.span`
  color: ${(props) => props.theme.secondary};
  font-size: 13px;
  margin-left: 50px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 0px;
    margin: 18px 0px;
  }
`;

export const RedirectLinksContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  padding-top: 10px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    margin-left: 26px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin-bottom: 15px;
    margin-left: 26px;
  }
`;

export const LinksGroup = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  a {
    margin-bottom: 5px;
    color: ${(props) => props.theme.primary};
    font-size: 14px;
  }
`;

export const LinksHeader = styled.span`
  color: ${(props) => props.theme.footerLinksHeaderColor};
  margin-bottom: 29px;
  text-transform: uppercase;
  opacity: 66%;
  letter-spacing: 0.1em;
  font-size: 14px;
`;

export const SocialMediaContainer = styled(Row)`
  width: 100%;
  padding-top: 59px;
  height: 40px;
  background-color: ${(props) => props.theme.background};

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    position: relative;
    height: auto;
    flex-direction: column;
    align-items: center;
  }

  a {
    margin-left: -140px;
    color: ${(props) => props.theme.secondary};
    font-size: 13px;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      margin-left: 0px;
    }
  }
`;

export const SocialMedias = styled.div`
  margin-right: 10px;
  svg {
    path {
      fill: ${(props) => props.theme.footerSocialMediaIconColor};
    }
  }
  a {
    margin: 0px 0px 0px 10px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
`;

export const RedirectGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const PoliciesContainer = styled.div`
  margin-left: 10px;
  display: flex;
  color: #fff;
  align-items: center;

  a {
    margin: 0px 10px;
    color: #979AA8;
  }

  a:hover {
    color: white;
  }

  aside {
    color: #FFF; 
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    display: flex;
    justify-content: center;
  }
`;

export const CustomColumn = styled(Col)`
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin-left: 8.33% !important;
  }
  margin-left: 0px !important;
`;
